import React, { FC } from 'react'

import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { ReactSVG } from 'react-svg'
import { RootState } from '../../../../states/containers/store'
import { isAdministrator } from '../../../../utils/role'

interface MiniMenuState {
  display: boolean,
  x: number,
  y: number,
  id: number | undefined,
  status: string,
}

interface Props {
  miniMenuState: MiniMenuState,
  closeCallback: VoidFunction,
  deleteCallback: VoidFunction,
  delegationCallback: VoidFunction,
}

const MiniMenu: FC<Props> = (props) => {
  const { t } = useTranslation()

  const {
    miniMenuState,
    closeCallback,
    deleteCallback,
    delegationCallback,
  } = props

  const {
    commonPart,
  } = useSelector((state: RootState) => (state))

  return (
    <>
      <div className={`mini_menu ${miniMenuState.display || 'none'}`} style={{ top: miniMenuState.y, left: miniMenuState.x }}>
        <ul>
          {
            isAdministrator(commonPart.role) && (
              <li>
                <button
                  type="button"
                  onClick={() => delegationCallback()}
                >
                  <ReactSVG
                    src="/static/images/icon/icon-setting.svg"
                    className="icon"
                  />
                  {t('setting.admin.delegation')}
                </button>
              </li>
            )
          }
          <li>
            <button
              type="button"
              onClick={() => deleteCallback()}
            >
              <ReactSVG
                src="/static/images/icon/icon-trash.svg"
                className="icon"
              />
              {t('setting.admin.delete')}
            </button>
          </li>
        </ul>
      </div>
      <div className={`close_screen gray ${miniMenuState.display || 'none'}`} role="presentation" onClick={closeCallback} />
    </>
  )
}

export default MiniMenu
